/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BranchCreateDto } from '../../models/branch-create-dto';
import { BranchDto } from '../../models/branch-dto';

export interface BranchAdminControllerCreateV1$Params {
      body: BranchCreateDto
}

export function branchAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: BranchAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BranchDto>> {
  const rb = new RequestBuilder(rootUrl, branchAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BranchDto>;
    })
  );
}

branchAdminControllerCreateV1.PATH = '/api/v1/branches/admin';
